import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "coreTiersContainer", "coreTierRow",
    "payrollTiersContainer", "payrollTierRow",
    "optionalTiersContainer", "optionalTierRow",
    "engagementContainer", "engagementRow",
    "symbolicTiersContainer", "symbolicTierRow",
    "driveTiersContainer", "driveTierRow",
    "storageExtContainer", "storageExtRow",
  ]

  removeRow(event) {
    const row = event.target.closest("[data-pricing-plan-tiers-target]")
    if (row) row.remove()
  }

  addCoreTier() {
    this._appendRow(this.coreTiersContainerTarget, this._coreTierHTML())
  }

  addPayrollTier() {
    this._appendRow(this.payrollTiersContainerTarget, this._payrollTierHTML())
  }

  addOptionalTier() {
    this._appendRow(this.optionalTiersContainerTarget, this._optionalTierHTML())
  }

  addEngagement() {
    this._appendRow(this.engagementContainerTarget, this._engagementHTML())
  }

  addSymbolicTier() {
    this._appendRow(this.symbolicTiersContainerTarget, this._symbolicTierHTML())
  }

  addDriveTier() {
    this._appendRow(this.driveTiersContainerTarget, this._driveTierHTML())
  }

  addStorageExtension() {
    this._appendRow(this.storageExtContainerTarget, this._storageExtHTML())
  }

  // Private

  _appendRow(container, html) {
    container.insertAdjacentHTML("beforeend", html)
  }

  _inputClass() {
    return "w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-cta focus:border-cta"
  }

  _deleteBtn() {
    return `<button type="button" data-action="click->pricing-plan-tiers#removeRow"
              class="mb-0.5 p-2 text-red-400 hover:text-red-600">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
              </svg>
            </button>`
  }

  _coreTierHTML() {
    const ic = this._inputClass()
    return `<div class="grid grid-cols-4 gap-3 mb-2 items-end" data-pricing-plan-tiers-target="coreTierRow">
      <div><label class="block text-xs text-gray-500 mb-1">Nom</label>
        <input type="text" name="pricing_plan[core_tiers][][name]" value="" placeholder="Nom du palier (optionnel)" class="${ic}"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Min</label>
        <input type="number" name="pricing_plan[core_tiers][][min_students]" value="0" class="${ic}" min="0"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Max</label>
        <input type="number" name="pricing_plan[core_tiers][][max_students]" value="" class="${ic}" min="0"></div>
      <div class="flex gap-2 items-end">
        <div class="flex-1"><label class="block text-xs text-gray-500 mb-1">Prix</label>
          <input type="number" name="pricing_plan[core_tiers][][base_price]" value="0" class="${ic}" min="0"></div>
        ${this._deleteBtn()}
      </div>
    </div>`
  }

  _payrollTierHTML() {
    const ic = this._inputClass()
    return `<div class="grid grid-cols-4 gap-3 mb-2 items-end" data-pricing-plan-tiers-target="payrollTierRow">
      <div><label class="block text-xs text-gray-500 mb-1">Nom</label>
        <input type="text" name="pricing_plan[payroll_tiers][][name]" value="" placeholder="Nom du palier (optionnel)" class="${ic}"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Min</label>
        <input type="number" name="pricing_plan[payroll_tiers][][min_staff]" value="0" class="${ic}" min="0"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Max</label>
        <input type="number" name="pricing_plan[payroll_tiers][][max_staff]" value="" class="${ic}" min="0"></div>
      <div class="flex gap-2 items-end">
        <div class="flex-1"><label class="block text-xs text-gray-500 mb-1">Prix</label>
          <input type="number" name="pricing_plan[payroll_tiers][][price]" value="0" class="${ic}" min="0"></div>
        ${this._deleteBtn()}
      </div>
    </div>`
  }

  _optionalTierHTML() {
    const ic = this._inputClass()
    const modules = [
      'go4scom', 'go4sxpense', 'go4stock', 'go4scount',
      'go4sfleet', 'go4shealth', 'go4scatering', 'go4slearn',
    ]
    const moduleInputs = modules.map(key => `
      <div><label class="block text-xs text-gray-500 mb-1">${key.toUpperCase()}</label>
        <input type="number" name="pricing_plan[optional_module_tiers][][${key}]" value="0" class="${ic}" min="0"></div>`
    ).join('')
    return `<div class="border border-gray-200 rounded-lg p-4 mb-3" data-pricing-plan-tiers-target="optionalTierRow">
      <div class="flex items-start justify-between gap-3 mb-4">
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 flex-1">
          <div><label class="block text-xs text-gray-500 mb-1">Nom</label>
            <input type="text" name="pricing_plan[optional_module_tiers][][name]" value="" placeholder="Optionnel" class="${ic}"></div>
          <div><label class="block text-xs text-gray-500 mb-1">Min total</label>
            <input type="number" name="pricing_plan[optional_module_tiers][][min_total]" value="0" class="${ic}" min="0"></div>
          <div><label class="block text-xs text-gray-500 mb-1">Max total</label>
            <input type="number" name="pricing_plan[optional_module_tiers][][max_total]" value="" class="${ic}" min="0"></div>
        </div>
        ${this._deleteBtn()}
      </div>
      <p class="text-xs font-medium text-gray-500 mb-2">Prix des modules</p>
      <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">${moduleInputs}</div>
    </div>`
  }

  _symbolicTierHTML() {
    const ic = this._inputClass()
    return `<div class="grid grid-cols-4 gap-3 mb-2 items-end" data-pricing-plan-tiers-target="symbolicTierRow">
      <div><label class="block text-xs text-gray-500 mb-1">Nom</label>
        <input type="text" name="pricing_plan[symbolic_tiers][][name]" value="" placeholder="Nom du palier (optionnel)" class="${ic}"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Min total</label>
        <input type="number" name="pricing_plan[symbolic_tiers][][min_total]" value="0" class="${ic}" min="0"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Max total</label>
        <input type="number" name="pricing_plan[symbolic_tiers][][max_total]" value="" class="${ic}" min="0"></div>
      <div class="flex gap-2 items-end">
        <div class="flex-1"><label class="block text-xs text-gray-500 mb-1">Prix</label>
          <input type="number" name="pricing_plan[symbolic_tiers][][price]" value="0" class="${ic}" min="0"></div>
        ${this._deleteBtn()}
      </div>
    </div>`
  }

  _driveTierHTML() {
    const ic = this._inputClass()
    return `<div class="grid grid-cols-5 gap-3 mb-2 items-end" data-pricing-plan-tiers-target="driveTierRow">
      <div><label class="block text-xs text-gray-500 mb-1">Nom</label>
        <input type="text" name="pricing_plan[drive_tiers][][name]" value="" placeholder="Nom du palier (optionnel)" class="${ic}"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Min total</label>
        <input type="number" name="pricing_plan[drive_tiers][][min_total]" value="0" class="${ic}" min="0"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Max total</label>
        <input type="number" name="pricing_plan[drive_tiers][][max_total]" value="" class="${ic}" min="0"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Stockage inclus</label>
        <input type="text" name="pricing_plan[drive_tiers][][storage_included]" value="" class="${ic}"></div>
      <div class="flex gap-2 items-end">
        <div class="flex-1"><label class="block text-xs text-gray-500 mb-1">Prix</label>
          <input type="number" name="pricing_plan[drive_tiers][][price]" value="0" class="${ic}" min="0"></div>
        ${this._deleteBtn()}
      </div>
    </div>`
  }

  _storageExtHTML() {
    const ic = this._inputClass()
    return `<div class="grid grid-cols-3 gap-3 mb-2 items-end" data-pricing-plan-tiers-target="storageExtRow">
      <div><label class="block text-xs text-gray-500 mb-1">Nom</label>
        <input type="text" name="pricing_plan[storage_extensions][][name]" value="" class="${ic}"></div>
      <div><label class="block text-xs text-gray-500 mb-1">Taille</label>
        <input type="text" name="pricing_plan[storage_extensions][][size]" value="" class="${ic}"></div>
      <div class="flex gap-2 items-end">
        <div class="flex-1"><label class="block text-xs text-gray-500 mb-1">Prix annuel</label>
          <input type="number" name="pricing_plan[storage_extensions][][price]" value="0" class="${ic}" min="0"></div>
        ${this._deleteBtn()}
      </div>
    </div>`
  }

  _engagementHTML() {
    const ic = this._inputClass()
    return `<div class="grid grid-cols-2 gap-3 mb-2 items-end" data-pricing-plan-tiers-target="engagementRow">
      <div><label class="block text-xs text-gray-500 mb-1">Annees</label>
        <input type="number" name="pricing_plan[engagement_discounts][][years]" value="1" class="${ic}" min="1"></div>
      <div class="flex gap-2 items-end">
        <div class="flex-1"><label class="block text-xs text-gray-500 mb-1">Remise %</label>
          <input type="number" name="pricing_plan[engagement_discounts][][discount_percentage]" value="0" class="${ic}" min="0" max="100" step="0.01"></div>
        ${this._deleteBtn()}
      </div>
    </div>`
  }
}
